import React from 'react';

import Box from '@mui/material/Box';

import Record from 'ui/Record/Record';

import { MainHeader } from 'components/MainHeader/MainHeader';

import routes from 'core/routes';

import { useNavBarHeight } from 'utils/hooks/navbar';

import UserList from './components/UserList';
import AddUsersModal from './components/AddUsersModal';
import AddMultipleUsersModal from './components/AddMultipleUsersModal';

const Users: React.FunctionComponent = (): React.ReactElement => {
  const navBarHeight = useNavBarHeight();
  const refreshRef = React.useRef<Function | null>(null);
  const onRefreshCallback = (callback: Function): void => {
    refreshRef.current = callback;
  };

  const onCloseRefresh = (): void => {
    if (refreshRef.current) {
      refreshRef.current();
    }
  };

  return (
    <Record
      Header={
        <MainHeader
          title="Users"
          breadcrumbs={[
            { label: 'Organisation', link: '' },
            { label: 'Users', link: routes.dashboard.settings.users.toString() },
          ]}
          action={
            <Box sx={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
              <AddMultipleUsersModal onCloseRefresh={onCloseRefresh} />
              <AddUsersModal onCloseRefresh={onCloseRefresh} />
            </Box>
          }
        />
      }
      Content={(onError) => <UserList onError={onError} onRefreshCallback={onRefreshCallback} />}
      navBarHeight={navBarHeight}
    />
  );
};

export default Users;
